import { Box, makeStyles, Theme, Typography } from '@material-ui/core';
import { HeroSection, ImageDescription } from 'components/structures/general';
import {
  bgPhone1x,
  bgPhone2x,
  heroBgDark,
  heroBgLight,
  seoBgSvg,
  seoImage1x,
  seoImage2x,
  smmImage,
  smmImage2x,
} from 'images/digital-marketing';
import { NextPage } from 'next';
import React from 'react';
import {
  BestWork,
  ContentMarketingBlock,
  ContextualAdvertising,
  DigitalMarketingBlock,
  MarketingAutomationBlock,
  UndisputedBenefits,
} from 'templates/digital-marketing';
import { RequestForm, SEO } from 'templates/layout';

const useStyles = makeStyles((theme: Theme) => ({
  list: {
    '& li': {
      color: theme.palette.primary.main,
      fontWeight: 700,
    },
  },
}));

const DigitalMarketing: NextPage = () => {
  const classes = useStyles();
  return (
    <>
      <SEO
        title="Digital marketing"
        description="Deploying website optimization services to get your webpage to the top of search issuance. Using cutting-edge website optimization tools to deliver results."
      />
      <HeroSection
        title="Digital marketing"
        description="With the latest industry trends, tools, and solutions in mind, we offer unbiased, transparent, and, above all else, efficient Digital Marketing services bound to help your business expand its target audience, generate new leads, and boost its online rankings."
        phoneImage={{ x1: bgPhone1x, x2: bgPhone2x }}
        bgImage={{ dark: heroBgDark, light: heroBgLight }}
      />
      <DigitalMarketingBlock />
      <UndisputedBenefits />
      <ImageDescription
        title={'Search engine optimization (SEO)'}
        upperTitle="Higher rankings"
        align="right"
        image={{ image: seoImage1x, srcSet: `${seoImage1x} 1x, ${seoImage2x} 2x` }}
        bgImage={{ image: seoBgSvg }}
      >
        <Typography>
          This is the process of optimizing a website to improve its ranking on search engine results pages and to increase the
          volume of organic (or free) traffic. At US Software Solutions, SEO includes the following steps:
        </Typography>
        <Box my={4}>
          <Typography component="ul" className={classes.list}>
            <Typography component="li">Optimization of pages</Typography>
            <Typography component="li">Technical optimization</Typography>
            <Typography component="li">External optimization</Typography>
          </Typography>
        </Box>
        <Typography>
          The promotion strategy is developed individually since different approaches are used to achieve different goals -
          building brand awareness, increasing sales or improving business performance.
        </Typography>
      </ImageDescription>
      <ContentMarketingBlock />
      <ImageDescription
        title={'Social media marketing (SMM)'}
        upperTitle="Media exposure"
        align="right"
        image={{ image: smmImage, srcSet: `${smmImage} 1x, ${smmImage2x} 2x` }}
        bgImage={{ image: seoBgSvg }}
      >
        <Typography>
          Social media marketing drives traffic and increases brand awareness by engaging people in online discussions and
          interactions. The most popular platforms are:
        </Typography>
        <Box my={4}>
          <Typography component="ul" className={classes.list}>
            <Typography component="li">Facebook</Typography>
            <Typography component="li">Instagram</Typography>
            <Typography component="li">LinkedIn</Typography>
            <Typography component="li">YouTube</Typography>
          </Typography>
        </Box>
        <Typography>
          SMM has become a popular way to attract attention. It is the most popular information medium for B2C marketers and is
          also gaining ground in the B2B arena. With US Software Solutions, you get essential SMM services that will cover your
          needs in full.
        </Typography>
      </ImageDescription>
      <ContextualAdvertising />
      <MarketingAutomationBlock />
      <BestWork />
      <RequestForm />
    </>
  );
};

export default DigitalMarketing;
